const zh = {
  // layout
  commons: {
    studentAndClassTypeList: '学员可选班级类型',
    adminList: '管理员列表',
    memberCoursePackage: '会员课包列表',
    classtypes: '班级类型列表',
    coursepackages: '课包列表',
    coursepackagesRecycleBin: '课包回收站',
    coursetypes: '课程类型列表',
    appointmenttypes: '预约类型列表',
    classhourSpendLists: '课时账单列表',
    memberRecycleBin: '会员回收站',
    messageNotify: '短信通知列表',
    locationAndClasstypeAndCoursepackage: '地点与班级类型关系列表',
    classtypeAndTime: '班级类型与时间列表',
    locationAndCounts: '地点与学员人数列表',
    resourceManage: '资源管理',
    courseManage: '课程管理',
    memberManage: '会员管理',
    schoolLists: '校区列表',
    typeManage: '类型管理',
    shouyeMange: '首页管理',
    coursePackageManage: '课包管理',
    operationRecord: '操作记录列表',
    studentManage: '学生管理',
    excel: '导出表格',
    showLists: '展示栏目列表',
    eventLists: '事件备注',
    courseResourse: '课程地点列表',
    unBeginCourseList: '未完课列表',
    notification: '消息提示',
    finishedCourseLists: '完课列表',
    cancelCourseList: '取消课程列表',
    courseDetails: '课程详情',
    recordList: '课堂记录',
    memberLists: '会员列表',
    studentLists: '学员列表',
    studentsRecycleBin: '学员回收站',
    courceLists: '课程列表',
    coachLists: '教练列表',
    xiaoai: '小爱',
    xiaohuojian: '小火箭',
    admin: '管理员',
    editor: '赵晓编',
    quit: '退出',
    hi: '您好',
    index: '首页',
    userManage: '用户管理',
    share: '分享功能',
    infoManage: '信息管理',
    infoShow: '个人信息',
    infoShow1: '个人信息子菜单1',
    infoShow2: '个人信息子菜单2',
    infoShow3: '个人信息子菜单3',
    infoShow4: '个人信息子菜单4',
    infoShow5: '个人信息子菜单5',
    infoModify: '修改信息',
    infoModify1: '修改信息子菜单1',
    infoModify2: '修改信息子菜单2',
    infoModify3: '修改信息子菜单3',
    fundManage: '资金管理',
    fundList: '资金流水',
    chinaTabsList: '区域投资',
    fundData: '资金数据',
    fundPosition: '投资分布',
    typePosition: '项目分布',
    incomePayPosition: '收支分布',
    permission: '权限设置',
    pagePer: '页面权限',
    directivePer: '按钮权限',
    errorPage: '错误页面',
    page401: '401',
    page404: '404',
    wechatNumber: '微信号'
  },
  index: {
    yearLoss: '年度总盈亏',
    yearProfit: '年度收益率',
    potentialInvestor: '潜在投资人',
    intentionInvestor: '意向投资人',
    waitExamineInvestor: '待审投资人',
    examiningInvestor: '审核中投资人',
    tenMillion: '千万元',
    person: '人'
  }
}

export default zh;